export enum DepositKeyTypeEnum {
  pix = "brapay", //PIX支付KEY
  spei = "international", //SPEI支付key
  usdt = "usdtPay",
  eWallet = "eWallet", //电子钱包
  betPay = "betPay", //betPay
  crypto = "crypto", //加密货币
  crossPay = "crossPay", //跨币种支付方式
  brlPZPay = "brlPZPay", //巴西联邦银行卡
}

export enum PutTypeEnum {
  usdt = 5,
  pixCpf = 7,
  pixCnpj = 8,
  pixEmail = 9,
  pixPhone = 10,
  speiCalbe = 3,
}
export enum PutGroupEnum {
  spei = 3,
  usdt = 5,
  pix = 7,
  eWallet = 6,
  SABank = 8, //南美洲银行卡提现通道
  betPay = 11,
  crypto = 9,
  bankCard = 12, //用户绑定银行卡
  creditCard = 13, //信用卡
}

export enum currencyToCountry {
  USD = "USA",
  BRL = "Brazil(Brasil)",
  MXN = "Mexico(México)",
  PEN = "Peru(Perú)",
  COP = "Colombia",
  PHP = "Philippines",
  NGN = "Nigeria",
  IDR = "Indonesia",
  INR = "India(भारत)",
  BDT = "Bangladesh(বাংলাদেশ)",
  HKD = "Hong Kong(香港)",
  MYR = "Malaysia(malɛjsia)",
  KRW = "Korea(한국)",
  ARS = "Argentina",
  CLP = "Chile",
  EUSD = "Ecuador",
  ZMW = "Zambia",
  PKR = "پاکستان",
  VND = "Việt Nam",
  THB = "ประเทศไทย",
  CAD = "Canada",
  TRY = "Türkiye",
}
